// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"ae3c9708","197":"fb32413e","261":"f7c56160","397":"50de2d33","430":"3c2602ec","490":"4241fee4","693":"ef2205c7","942":"6039d738"}[chunkId] + ".chunk.css";
};